import { groupBy, uniq } from "lodash";
import type { Maybe, OddsSelection } from "@/graphql/gql/graphql";

type Odds = Maybe<OddsSelection>[];

/**
 * @param headToHeadSlug like "8867/falcons-saints"
 */
export const buildHead2HeadPath = (headToHeadSlug: string) =>
  `/nfl/matchups/${headToHeadSlug}`;

export const getUniquePlayerNumberfireIds = (odds: Odds) =>
  uniq(odds.map((el) => el?.player?.numberfireId)).filter((id) => id != null);

export const groupByPlayerNumberfireId = (odds: Odds) =>
  groupBy(odds, "player.numberfireId");
